import React from 'react';
import { motion } from 'framer-motion';
import { CreditCardIcon, FileTextIcon, LockIcon, ShoppingCartIcon, StarIcon, TrendingUpIcon, ZapIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { heroTestimonials } from '../data/content';
const MOCKUP_URL = 'https://cdn.magicpatterns.com/uploads/werbiFwLEiuaMUELe1gRkF/MOCKUP_-_Calistenia_0_limites.png';
const badges = [{
  icon: FileTextIcon,
  label: '100% PDF'
}, {
  icon: ZapIcon,
  label: 'Acceso en 5 min'
}, {
  icon: TrendingUpIcon,
  label: 'Principiante → Élite'
}, {
  icon: StarIcon,
  label: 'Todos los niveles'
}];
const stats = [{
  value: '+500',
  label: 'atletas confían'
}, {
  value: '6',
  label: 'Tomos listos'
}, {
  value: '6',
  label: 'Bonos incluidos'
}, {
  value: '4.9/5',
  label: 'calificación ⭐'
}];
function Stars() {
  return <div className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-121" data-mp="3d33f4zea6vla">
      {Array.from({
      length: 5
    }).map((_, index) => <StarIcon key={index} className="h-3.5 w-3.5 fill-gold text-gold" aria-hidden="true" data-id="element-122" data-mp="384jq2q4e53op" data-mpi={index} />)}
    </div>;
}
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-ink" data-id="element-123" data-mp="3o5j3nbh1flmc">
      <div className="pointer-events-none absolute left-1/2 top-0 h-[520px] w-[900px] -translate-x-1/2 rounded-full bg-electric/10 blur-[140px]" aria-hidden="true" data-id="element-124" data-mp="399bctsb4jly3" />
      <div className="relative mx-auto max-w-6xl px-5 pb-16 pt-10 text-center sm:px-8 sm:pb-24 sm:pt-14" data-id="element-125" data-mp="30hrjxmt646b1">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4
      }} className="text-base font-extrabold uppercase tracking-[0.22em] text-gold sm:text-lg" data-id="element-126" data-mp="359syxghq0b4r">
          🏋️ Nucleo Fit™
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.05
      }} className="mx-auto mt-6 max-w-4xl text-[2.5rem] font-extrabold leading-[1.02] tracking-tight text-white sm:text-6xl lg:text-7xl" data-id="element-127" data-mp="2hk8522k13tgp">
          Todo tu sistema de calistenia.
          <span className="mt-2 block text-gold-gradient" data-id="element-128" data-mp="n98g9vpnzjrl">Listo. Desde hoy.</span>
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.94
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.12,
        ease: 'easeOut'
      }} className="relative mx-auto mt-10 max-w-3xl" data-id="element-129" data-mp="i9vqb23hxwks">
          <img src={MOCKUP_URL} alt="Megakit Calistenia Cero Límites: 6 tomos, checklists, planillas y bonos en PDF" className="mx-auto w-full drop-shadow-[0_35px_60px_rgba(46,155,255,0.25)]" width={1024} height={1024} data-id="element-130" data-mp="162ued0zp7h57" />
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="mx-auto mt-6 max-w-3xl text-lg font-bold leading-snug text-gold sm:text-xl" data-id="element-131" data-mp="3ltqclcptivti">
          El sistema N°1 para atletas de calistenia en Argentina — Principiante →
          Élite — Todos los niveles
        </motion.p>

        <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-neutral-300 sm:text-lg" data-id="element-132" data-mp="268y69llgo553">
          Fundamentos + progresiones + nutrición + programación listos para usar.
          Sin buscar. Sin improvisar. Sin perder semanas sin avanzar.
        </p>

        <ul className="mx-auto mt-8 flex max-w-3xl flex-wrap items-center justify-center gap-2.5" data-id="element-133" data-mp="2kyna5okxun92">
          {badges.map(({
          icon: Icon,
          label
        }) => <li key={label} className="inline-flex items-center gap-2 rounded-full border border-line bg-surface px-4 py-2 text-xs font-bold text-neutral-200 sm:text-sm" data-id="element-134" data-mp="2p10dk6c7q92o">
              <Icon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-135" data-mp="uoany0svnm13" />
              {label}
            </li>)}
        </ul>

        <div className="mx-auto mt-9 max-w-md" data-id="element-136" data-mp="4b461q1btyhv">
          <CtaButton className="py-5 text-base sm:text-lg" data-id="element-137" data-mp="49t1vp3yyoq8">
            QUIERO MI MEGAKIT AHORA
          </CtaButton>
          <ul className="mt-4 flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-xs font-medium text-neutral-500" data-id="element-138" data-mp="3vjrtcbj4nvs2">
            <li className="inline-flex items-center gap-1.5" data-id="element-139" data-mp="9aqkg2sw5ks9">
              <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-140" data-mp="9b8mjg28it83" />
              Garantía 7 días
            </li>
            <li className="inline-flex items-center gap-1.5" data-id="element-141" data-mp="3hnxt0gwf6eqk">
              <CreditCardIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-142" data-mp="3csifxr68kmv7" />
              Pago seguro
            </li>
            <li className="inline-flex items-center gap-1.5" data-id="element-143" data-mp="3rhep5rk145xe">
              <ShoppingCartIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-144" data-mp="3mp3r6u8umu7h" />
              Mercado Pago
            </li>
          </ul>
        </div>

        <dl className="mx-auto mt-14 grid max-w-4xl grid-cols-2 gap-3 sm:grid-cols-4" data-id="element-145" data-mp="2yxogad30b4km">
          {stats.map(stat => <div key={stat.label} className="rounded-2xl border border-line bg-surface px-4 py-5" data-id="element-146" data-mp="19ixbbwxsbc90">
              <dt className="sr-only" data-id="element-147" data-mp="1ea5moyiod7ot">{stat.label}</dt>
              <dd data-id="element-148" data-mp="zkhgpjzjtkur">
                <span className="block text-2xl font-extrabold text-gold sm:text-3xl" data-id="element-149" data-mp="zl93q6f2ya9f">
                  {stat.value}
                </span>
                <span className="mt-1 block text-xs font-medium text-neutral-400" data-id="element-150" data-mp="14ju5wbdw740i">
                  {stat.label}
                </span>
              </dd>
            </div>)}
        </dl>

        <ul className="mx-auto mt-6 grid max-w-6xl gap-4 text-left lg:grid-cols-3" data-id="element-151" data-mp="1x7gk0dkqxr1m">
          {heroTestimonials.map(item => <li key={item.initials} className="rounded-2xl border border-line bg-surface p-5" data-id="element-152" data-mp="1na24cg6nd6ad">
              <div className="flex items-center gap-3" data-id="element-153" data-mp="7s8owteolgoi">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-gold/15 text-sm font-extrabold text-gold" data-id="element-154" data-mp="7vo37u0j6lov">
                  {item.initials}
                </span>
                <Stars data-id="element-155" data-mp="29iha7pmlwh3m" />
              </div>
              <p className="mt-3 text-sm leading-relaxed text-neutral-300" data-id="element-156" data-mp="29jio01v0bhp1">
                “{item.quote}”
              </p>
              <p className="mt-3 text-xs font-bold text-neutral-500" data-id="element-157" data-mp="24pxxeuvqtpzv">
                — {item.name}, {item.location}
              </p>
            </li>)}
        </ul>
      </div>
    </header>;
}